import React from 'react';
import PropTypes from 'prop-types';

import ConfirmTemplates from '../ConfirmTemplates';
import ConfirmModal from '../../../../../../components/Modal/Confirm';

const ModalsManager = ({ open, isLoadingSubmit, modalData, values, statuses, onSubmit, onHide }) => (
  <>
    <ConfirmModal
      toggle={onHide}
      isOpen={open === 'confirm'}
      fetching={isLoadingSubmit}
      onConfirm={() => onSubmit('confirm')}
      confirmBtnText="Delete"
      title={<ConfirmTemplates.Title {...modalData} />}
      description={<ConfirmTemplates.Body selectedCount={values?.length || 0} statuses={statuses} {...modalData} />}
    />
  </>
);

ModalsManager.propTypes = {
  open: PropTypes.string,
  isLoading: PropTypes.bool,
  isLoadingSubmit: PropTypes.bool,
  modalData: PropTypes.object,
  values: PropTypes.array,
  statuses: PropTypes.array,
  onSubmit: PropTypes.func,
  onHide: PropTypes.func,
};

export default ModalsManager;
